/**
 * Форматирует адрес в краткий формат: "BY, 220000 Минск"
 * @param {Object} address - объект адреса
 * @returns {string} - отформатированный адрес
 */
export function formatShortAddress(address) {
    if (!address) return "";

    const parts = [];

    // Код страны
    if (address.country_code) {
        parts.push(address.country_code);
    }

    // Почтовый индекс и город
    const cityPart = [address.post_code, address.city || address.country]
        .filter(Boolean)
        .join(" ");

    if (cityPart) {
        parts.push(cityPart);
    }

    return parts.join(", ");
}
